"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _intents = _interopRequireWildcard(require("@ux/intents"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var _default = exports.default = function () {
  const intents = new _intents.default();
  intents.create('@ux/tray-menu', {
    styleProperties: [_intents.enums.properties.BACKGROUND_COLOR, _intents.enums.properties.FONT_SIZE],
    interactions: [_intents.enums.interactions.CHOSEN],
    features: {
      // Menu button
      [_intents.enums.features.INDICATOR]: {
        styleProperties: [_intents.enums.properties.FONT_SIZE, _intents.enums.properties.FONT_WEIGHT, _intents.enums.properties.BORDER_RADIUS]
      }
    }
  });

  // Menu container default
  intents.uxTrayMenu.backgroundColor = 'transparent';
  intents.uxTrayMenu.fontSize = intents.ux.text.fontSize;

  // Menu contrainer open
  intents.uxTrayMenuChosen.backgroundColor = intents.ux.boxLowContrast.backgroundColor;

  // Menu button
  intents.uxTrayMenu.indicator.fontSize = intents.ux.textAction.fontSize;
  intents.uxTrayMenu.indicator.fontWeight = intents.ux.textAction.fontWeight;
  intents.uxTrayMenu.indicator.borderRadius = intents.ux.action.borderRadius;
  return intents;
}();